export default __webpack_public_path__ + "static/media/guitarra.d8f08eb9.png";